export const GET_ALL_UI_COLOR_FONT_REQUEST = "GET_ALL_UI_COLOR_FONT_REQUEST";
export const GET_ALL_UI_COLOR_FONT_FAILURE = "GET_ALL_UI_COLOR_FONT_FAILURE";
export const GET_ALL_UI_COLOR_FONT_SUCCESS = "GET_ALL_UI_COLOR_FONT_SUCCESS";